<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="100" inline>
        <FormItem label="设备SN号">
          <Input placeholder="请输入" v-model="table.search.ClientSN"></Input>
        </FormItem>
        <FormItem label="设备名称">
          <Input placeholder="请输入" v-model="table.search.ClientName"></Input>
        </FormItem>
        <FormItem label="设备类型">
          <Input placeholder="请输入" v-model="table.search.ClientType"></Input>
        </FormItem>
      </Form>
      <!--操作区域-->
      <div>
        <Button class="mr-3" type="success" @click="search">查询</Button>
        <Button class="mr-3" type="primary" @click="addModal = true">新增</Button>
        <Button class="mr-3" type="warning" @click="deleteBatch">批量删除</Button>
      </div>

    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

    <!--新增-->
    <Modal
      v-model="addModal"
      title="新增"
      :footer-hide="true"
      
      :closable="false"
    >
      <clientDetailadd
        @close="addModal = false"
        @loadData="search"
      ></clientDetailadd>
    </Modal>

    <!--更新-->
    <Modal
      v-model="editModal"
      title="更新"
      :footer-hide="true"
      
      :closable="false"
    >
      <clientDetailedit
        v-if="editModal"
        @close="editModal = false"
        @loadData="search"
        :currentData="currentData"
      ></clientDetailedit>
    </Modal>

    <!--详情-->
    <Modal
      v-model="detailModal"
      title="详情"
      :footer-hide="true"
      
      :closable="false"
    >
      <clientDetaildetail
        v-if="detailModal"
        @close="detailModal = false"
        :currentData="currentData"
      ></clientDetaildetail>
    </Modal>

    <!--初始化配置-->
    <Modal
      v-model="initConfigModal"
      title="初始化配置"
      :footer-hide="true"
      
      :closable="false"
    >
      <clientDetailinitConfig
        v-if="initConfigModal"
        @close="initConfigModal = false"
        :currentData="currentData"
      ></clientDetailinitConfig>
    </Modal>
    <!--Xml详情-->
    <Modal
      v-model="xmllistModal"
      title="Xml详情"
      :footer-hide="true" width="1100px"
      
      :closable="true"
    >
      <xmllist
        v-if="xmllistModal"
        @close="xmllistModal = false"
        :clientSN="ClientSN"
      ></xmllist>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import clientDetailadd from "../clientDetail/add.vue";
import clientDetailedit from "../clientDetail/edit.vue";
import clientDetaildetail from "../clientDetail/detail.vue";
import clientDetailinitConfig from "../clientDetail/initconfig.vue";
import xmllist from "../clientXml/xmllist.vue";

export default {
  props: ["ClientId"],
  components: {
    DataTable,
    clientDetailadd,
    clientDetailedit,
    clientDetaildetail,
    clientDetailinitConfig,
    xmllist,
  },
  data: function () {
    return {
      currentData: {},
      detailModal: false,
      addModal: false,
      editModal: false,
      initConfigModal: false,
      xmllistModal: false,
      ClientSN: "",
      selectionData: [],
      table: {
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "设备SN码", key: "clientSN" },
          { title: "设备名称", key: "clientName" },
          { title: "设备类型", key: "clientType" },
          { title: "产品类型", key: "projectName" },
          { title: "所属主设备", key: "mainClientName" },
          { title: "所属机构", key: "organName" },
          {
            title: "是否激活",
            key: "isActived",
            width: "80",
            render: (h, value) => {
              return h("div", value.row.isActived == "0" ? "否" : "是");
            },
          },
          {
            title: "操作",
            width: "380px",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toInitConfig(params.row);
                      },
                    },
                  },
                  "初始化"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toXml(params.row);
                      },
                    },
                  },
                  "Xml"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.lockedHandler(params.row);
                      },
                    },
                  },
                  params.row.isActived == "0" ? "激活" : "锁定"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                      color:'#FA6266',
                    },
                    style: {
                      marginRight: "5px",
                      color:'#FA6266',
                    },
                    on: {
                      click: () => {
                        this.deleteSingle(params.row.clientDetailID);
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        apiUrl:
          "clientDetail/getList?ClientId=" +
          (this.ClientId ? this.ClientId : ""),
        search: {
          ClientSN: "",
          ClientName: "",
          ClientType: "",
        },
      },
    };
  },

  mounted(){
    this.search()
  },

  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },

    toEdit: function (data) {
      this.editModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },
    toXml: function (data) {
      this.xmllistModal = true;
      this.ClientSN = data.clientSN;
    },
    toInitConfig: function (data) {
      this.$api
        .get(`/clientversion/getListByClientSN?clientSN=${data.clientSN}`)
        .then((rsp) => {
          if (rsp.data.length > 0) {
            this.$Modal.confirm({
              title: "该设备已初始化过配置信息，是否需要覆盖原配置？",
              mask: false,
              onOk: () => {
                this.initConfigModal = true;
                this.currentData = JSON.parse(JSON.stringify(data));
              },
            });
          } else {
            this.initConfigModal = true;
            this.currentData = JSON.parse(JSON.stringify(data));
          }
        });
    },

    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "会同步删除设备明细数据,是否继续？",
        mask: false,
        onOk: () => {
          this.$api.post(`/clientDetail/delete?id=${id}`).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("删除成功");
              this.search();
            }
          });
        },
      });
    },

    //批量删除
    deleteBatch() {
      if (this.selectionData.length < 1) {
        this.$Message.warning("请先勾选数据");
      } else {
        let ids = [];
        this.selectionData.forEach((item) => {
          ids.push(item.clientDetailID);
        });
        let _ids = ids.join(";");
        this.$Modal.confirm({
          title: "会同步删除设备明细数据,是否继续？",
          mask: false,
          onOk: () => {
            this.$api
              .post(`/clientDetail/deleteBatch?ids=${_ids}`)
              .then((rsp) => {
                if (rsp != false) {
                  this.$Message.success("删除成功");
                  this.search();
                }
              });
          },
        });
      }
    },
    lockedHandler: function (data) {
      let temp = data.isActived == "0" ? "激活" : "锁定";
      this.$Modal.confirm({
        title: `确认要${temp}该设备吗？`,
        mask: false,
        onOk: () => {
          this.$api
            .post(`/clientDetail/locked?id=${data.clientDetailID}`)
            .then((rsp) => {
              this.$Message.success(`${temp}成功`);
              this.search();
            });
        },
      });
    },
    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style scoped>
</style>